import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class DocumentBankStatementMeta extends BaseEntityModel {
  parentId?: number;

  startDate?: string;

  endDate?: string;

  constructor(model: Partial<DocumentBankStatementMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.startDate = model.startDate;
    this.endDate = model.endDate;
  }
}
